<ng-container *transloco="let t">
  <div class="documentsUploadedDialog">
    <h1 class="documentsUploadedDialog__title">
      <span class="textBlue">{{
        t('documentsUploadedDialog.title.one') | uppercase
      }}</span>
      <span [ngClass]="isWarranties ? 'textGreen' : 'textYellow'">{{
        t('documentsUploadedDialog.title.two') | uppercase
      }}</span>
    </h1>

    <p class="documentsUploadedDialog__description textBlue">
      {{ t('documentsUploadedDialog.description') }}
    </p>

    <button
      [ngClass]="isWarranties ? 'buttonGreen' : 'buttonYellow'"
      (click)="close()">
      {{ t('buttons.ok') }}
    </button>

    <p class="documentsUploadedDialog__info textGrey textSmall">
      {{ t('documentsUploadedDialog.wishes') }}
    </p>

    <a
      target="_blank"
      href="https://www.facebook.com/ubezpieczeniaGAP/">
      <button class="buttonBlue documentsUploadedDialog__facebookButton">
        <img
          src="assets/icons/fbWhite.svg"
          alt="" /><span>{{ t('buttons.fbLike') }}</span>
      </button>
    </a>
  </div>
</ng-container>
